import { render, staticRenderFns } from "./DashFeesSettlements.vue?vue&type=template&id=7e31d808&scoped=true&"
import script from "./DashFeesSettlements.vue?vue&type=script&lang=js&"
export * from "./DashFeesSettlements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e31d808",
  null
  
)

export default component.exports